import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowDown } from 'lucide-react';

function Row({ k, v, id }) {
  return (
    <div className="flex flex-wrap justify-between gap-x-4 gap-y-0.5 py-1.5 border-b border-white/5 text-sm">
      <span className="text-gray-500">{k}</span>
      <span className="text-gray-200 text-right" data-testid={id}>{v}</span>
    </div>
  );
}

export function ChargeResult({ charge, order, onUseOrder }) {
  if (!order) {
    return (
      <div className="rounded-xl border border-amber-500/50 p-4 text-sm text-amber-100/90" data-testid="charge-no-match">
        No order your agent placed explains this charge. Treat it as possibly unauthorized and contact your card issuer. This is a demo message only. Kojiru takes no action and makes no determination.
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-emerald-500/40 p-4" data-testid="charge-match">
      <p className="text-sm text-emerald-100/90 mb-3">Matched. <span className="font-mono">{charge.name}</span> is your order from {order.merchant}.</p>
      <Row k="Order" v={order.orderRef} id="charge-match-order" />
      <Row k="Store" v={order.merchant} id="charge-match-store" />
      <Row k="Bought by" v={order.agentId} id="charge-match-agent" />
      <Row k="Item" v={order.item} id="charge-match-item" />
      <Row k="Return policy at checkout" v={order.policy} id="charge-match-policy" />
      <div className="mt-3 rounded-lg border border-violet-400/30 bg-violet-400/[0.04] p-3 text-xs" data-testid="charge-policy-shown">
        <div className="text-violet-100/90" data-testid="charge-policy-shown-line">Policy shown to: agent at {order.policyShown.agent}, cardholder: {order.policyShown.principal ? `at ${order.policyShown.principal}` : 'not shown'}</div>
        <Link to="/specs/claim-records/comments" className="mt-1 inline-block text-violet-300 hover:text-violet-200" data-testid="charge-policy-shown-link">Not in Draft 0.4. Proposed for comment (Q-2)</Link>
      </div>
      <button type="button" onClick={() => onUseOrder(order, charge)} className="mt-4 inline-flex items-center gap-2 rounded-full bg-amber-300 text-black px-4 py-2 text-sm font-semibold hover:bg-amber-200 transition-colors" data-testid="charge-use-order-btn">
        <ArrowDown className="w-4 h-4" /> Start a claim on this order
      </button>
    </div>
  );
}
